import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PersonIcon from "@mui/icons-material/Person";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import CategoryIcon from "@mui/icons-material/Category";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";

import InventoryIcon from "@mui/icons-material/Inventory";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PaymentsIcon from "@mui/icons-material/Payments";
// import PublicIcon from "@mui/icons-material/Public";
// import PointOfSaleIcon from "@mui/icons-material/PointOfSale";

import AssessmentIcon from "@mui/icons-material/Assessment";
import BarChartIcon from "@mui/icons-material/BarChart";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import HistoryIcon from "@mui/icons-material/History";
import CodeIcon from "@mui/icons-material/Code";
// import SettingsIcon from "@mui/icons-material/Settings";

import AltRouteIcon from "@mui/icons-material/AltRoute";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
// import AssignmentIcon from "@mui/icons-material/Assignment";
// import SecurityIcon from "@mui/icons-material/Security";

export const menuSections = [
  {
    title: "Main Menu",
    items: [
      {
        name: "Dashboard",
        icon: <DashboardIcon fontSize="small" />,
        path: "/dashboard",
      },
      {
        name: "Users",
        icon: <PeopleIcon fontSize="small" />,
        children: [
          {
            name: "Customers",
            icon: <PersonIcon fontSize="small" />,
            path: "/users/customers",
          },
          {
            name: "Admins",
            icon: <AdminPanelSettingsIcon fontSize="small" />,
            path: "/users/admins",
          },
        ],
      },
      {
        name: "Transactions",
        icon: <SwapHorizIcon fontSize="small" />,
        path: "/transactions",
      },
      {
        name: "Settlements",
        icon: <PaymentsIcon fontSize="small" />,
        path: "/settlements",
      },
      {
        name: "Disputes",
        icon: <ReportProblemIcon fontSize="small" />,
        path: "/disputes",
      },
      {
        name: "Invoices",
        icon: <ReceiptOutlinedIcon fontSize="small" />,
        path: "/invoices",
      },
      {
        name: "KYC",
        icon: <VerifiedUserIcon fontSize="small" />,
        path: "/kyc",
        requiredRoles: [
          "ROLE_ADMIN_OWNER",
          "ROLE_ADMIN_SUPER",
        ],
      },
    ],
  },

  {
    title: "Operations",
    items: [
      {
        name: "Products",
        icon: <InventoryIcon fontSize="small" />,
        path: "/products",
      },

      // {
      //   name: "GL Management",
      //   icon: <ReceiptLongIcon fontSize="small" />,
      //   path: "/gl-management",
      // },
      {
        name: "Ledger",
        icon: <ReceiptLongIcon fontSize="small" />,
        path: "/ledger",
        requiredRoles: ["ROLE_ADMIN_OWNER"],
      },
      // {
      //   name: "International Remittance",
      //   icon: <PublicIcon fontSize="small" />,
      //   path: "/remittance",
      //   disabled: true,
      // },
      // {
      //   name: "Account Services",
      //   icon: <AccountBalanceIcon fontSize="small" />,
      //   path: "/account-services",
      //   disabled: true,
      // },
      // {
      //   name: "Virtual POS Terminal",
      //   icon: <PointOfSaleIcon fontSize="small" />,
      //   path: "/virtual-pos",
      //   disabled: true,
      // },
    ],
  },

  {
    title: "Admin & Reports",
    items: [
      {
        name: "Approval Management",
        icon: <AssessmentIcon fontSize="small" />,
        children: [
          {
            name: "Approvals",
            icon: <AssignmentTurnedInIcon fontSize="small" />,
            path: "/approvals/report",
          },
          {
            name: "Closure Requests",
            icon: <NoAccountsIcon fontSize="small" />,
            path: "/approvals/closure-request",
            requiredRoles: [
              "ROLE_ADMIN_OWNER",
              "ROLE_ADMIN_SUPER",
              "ROLE_ADMIN_APP",
            ],
          },
        ],
      },
      {
        name: "Waya Official",
        icon: <LockPersonIcon fontSize="small" />,
        path: "/waya-official",
        requiredRoles: ["ROLE_ADMIN_OWNER"],
      },
      // {
      //   name: "Regulatory Reporting",
      //   icon: <AssessmentIcon fontSize="small" />,
      //   path: "/regulatory-reporting",
      // },
      {
        name: "Internal Reporting",
        icon: <BarChartIcon fontSize="small" />,
        path: "/internal-reporting",
      },
      {
        name: "Activity Logs",
        icon: <HistoryIcon fontSize="small" />,
        path: "/logs/activity",
        // Single page for now — other log tabs commented out.
        // children: [
        //   {
        //     name: "Activity",
        //     icon: <ReceiptLongIcon fontSize="small" />,
        //     path: "/logs/activity",
        //   },
        //   {
        //     name: "Dispute",
        //     icon: <ReportProblemIcon fontSize="small" />,
        //     path: "/logs/disputes",
        //   },
        //   {
        //     name: "Request",
        //     icon: <AssignmentIcon fontSize="small" />,
        //     path: "/logs/requests",
        //   },
        //   {
        //     name: "Fraud Management",
        //     icon: <SecurityIcon fontSize="small" />,
        //     path: "/logs/fraud-management",
        //   },
        // ],
      },
      {
        name: "Notifications",
        icon: <NotificationsActiveOutlinedIcon fontSize="small" />,
        path: "/notifications",
        requiredRoles: [
          "ROLE_ADMIN_OWNER",
          "ROLE_ADMIN_SUPER",
          "ROLE_ADMIN_APP",
        ],
      },
      {
        name: "Admin Pricing",
        icon: <CodeIcon fontSize="small" />,
        children: [
          {
            name: "Category",
            icon: <CategoryIcon fontSize="small" />,
            path: "/admin-pricing/categories",
          },
          {
            name: "Pricing",
            icon: <PriceChangeIcon fontSize="small" />,
            path: "/admin-pricing/pricing",
          },
          {
            name: "Commission",
            icon: <RequestQuoteIcon fontSize="small" />,
            path: "/admin-pricing/commission",
          },
        ],
      },
      {
        name: "Tech",
        icon: <CodeIcon fontSize="small" />,
        children: [
          {
            name: "Transaction Routing",
            icon: <AltRouteIcon fontSize="small" />,
            path: "/tech/transaction-routing",
          },
          // {
          //   name: "Pricing",
          //   icon: <LocalOfferIcon fontSize="small" />,
          //   path: "/tech/pricings",
          // },
        ],
      },
      // {
      //   name: "Settings",
      //   icon: <SettingsIcon fontSize="small" />,
      //   path: "/settings",
      // },
    ],
  },
];
